import { IconButton, InputAdornment, TextField } from '@mui/material';
import { variants } from '../../../variants/variants';
import { FilterAltOutlined, SearchOutlined } from '@mui/icons-material';

const SearchBar = ({ value, handleSearchChange, sx, size = 'small' }) => {
  return (
    <TextField
      fullWidth
      onChange={handleSearchChange}
      value={value}
      size={size}
      placeholder='Search'
      sx={{
        fontSize: variants.BODY,
        borderBottom: 1,
        borderColor: 'divider',
        width: '100%',
        ...sx,
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <SearchOutlined />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchBar;
